import * as InstallationDashboardsAction from '../actions/installationDashboards.actions';
import { InstallationDashboardModel } from '../../../core/models/installation-dashboard.model';

export interface State {
  installationDashboards: Map<number, InstallationDashboardModel[]>;
  errors: any[] | null;
}

export const initialState: State = {
  installationDashboards: new Map<number, InstallationDashboardModel[]>(),
  errors: null
};
export function reducer(
  state = initialState,
  action: InstallationDashboardsAction.InstallationDashboardsActionsUnion
): State {
  switch (action.type) {
    case InstallationDashboardsAction.getInstallationDashboardsByUnitIdSuccess.type: {
      const map = new Map<number, InstallationDashboardModel[]>(state.installationDashboards);
      const errors: any[] = [];
      Array.from(action['data']?.keys()).forEach((unitId: number) => {
        const data = action['data']?.get(unitId);
        if (data?.errorMessageCode) {
          errors.push({...data, unitId});
        } else {
          map.set(unitId, data);
        }
      });

      return {
        ...state,
        installationDashboards: map,
        errors: errors?.length > 0 ? errors : null
      };
    }
    case InstallationDashboardsAction.getInstallationDashboardsByUnitIdFailure.type: {
      return {
        ...state,
        errors: action['error']
      }
    }
    default: {
      return state;
    }
  }
}
export const getInstallationDashboards = (state: State) => state.installationDashboards;
export const getInstallationDashboardsErrors = (state: State) => state.errors;
